import createVueComponent from '../createVueComponent';

const Clock8 = createVueComponent('Clock8Icon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 8 14', key: 'tmc9b4' }],
]);

export default Clock8;
